<template>
  <div id="app">
    <Canvas/>
  </div> 
</template>

<script>
import Canvas from './components/Canvas'

export default {
  name: 'App',
  components: {
    Canvas
  }
}
</script>

<style>
@import 'https://use.fontawesome.com/releases/v5.0.9/css/all.css';

</style>



// WEBPACK FOOTER //
// src/App.vue